import { BaseDTO } from '../basedto';
import { PartInfo } from '../partinfo';
import { SearchFilter } from './searchfilter';
import { BaseQueryDTO } from './basequery-dto';

export class QueryPartInfoSearchByPartNumberDTO extends BaseQueryDTO {
    PartNumber: string;
    SupplierCode: string;
}
